import { LOADING_SIBLINGS, RECEIVED_SIBLINGS, RECEIVED_SIBLINGS_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType, contentFamilyType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ metadata: { contentFamily, isbn }, pii, token }) => {
      let url;

      if (isbn && contentFamilyType.nonserial === contentFamily) {
        url = `/enhancements/article/nonserial/isbn/${isbn}/pii/${pii}/siblings?token=${token}`;
      } else if (contentFamilyType.serial === contentFamily) {
        url = `/enhancements/article/pii/${pii}/siblings?token=${token}`;
      }

      return url;
    },
  },
  fetch: createFetcher(LOADING_SIBLINGS, RECEIVED_SIBLINGS, RECEIVED_SIBLINGS_FAILED),
};
